import {
  BADGE_DETAIL_DISPLAY_NAME,
  BADGE_DISPLAY_NAME,
} from "../../../mappers/badge.codec";
import { UPSELL_POPUP_DISPLAY_NAME } from "../../../mappers/upsell-popup.codec";
import { SECTIONS } from "./pricing-sections";

const FIELD_SECTIONS: Readonly<Record<string, string>> = {
  name: "section-name",
  displayProductName: "section-name",
  description: "section-description",
  displayProductSubtitle: "section-description",
  "price.value": "section-price",
  "price.unit": "section-price",
  priceDiscountDuration: "section-price",
  unitOfMeasure: "section-validity",
  "unitOfMeasure.amount": "section-validity",
  "unitOfMeasure.units": "section-validity",
  "productOfferingTerm.duration.units": "section-billing",
  minimumServiceYears: "section-eligibility",
  maximumServiceYears: "section-eligibility",
  minimumCustomerAge: "section-eligibility",
  maximumCustomerAge: "section-eligibility",
  tariffContract: "section-online-store",
  "UrlSubdirectory-1": "section-online-store",
  "UrlSubdirectory-2": "section-online-store",
  "price-network-type": "section-classification",
  "price-effective-option": "section-classification",
  "price-agreement": "section-agreement",
  "attachment.icon": "section-services",
};

const SECTION_ID_ALIASES: Readonly<Record<string, string>> = {
  price: "section-price",
  "price-options": "section-price",
  internetBenefit: "section-services",
};

const PRICE_CARD_SECTIONS: Readonly<Record<string, string>> = {
  pricing: "section-price",
  display: "section-services",
  service: "section-services",
  eligibility: "section-eligibility",
  classification: "section-classification",
  agreement: "section-agreement",
};

const PRICE_CARD_ID = /^price(?:-option-\d+)?-([a-z]+)$/;

const SECTION_IDS: ReadonlySet<string> = new Set(SECTIONS.map((s) => s.id));

function sectionForFieldKey(fieldKey: string): string | null {
  const exact = FIELD_SECTIONS[fieldKey];
  if (exact) return exact;
  if (fieldKey.startsWith("tax.")) return "section-tax";
  const display = /^displays\.([^.]+)\./.exec(fieldKey)?.[1];
  if (display === BADGE_DISPLAY_NAME) return "section-badge";
  if (display === BADGE_DETAIL_DISPLAY_NAME) return "section-badge-detail";
  if (display === UPSELL_POPUP_DISPLAY_NAME) return "section-badge-upsell";
  if (display) return "section-services";
  if (/^display(Internet|Voice|Sms|Benefit)/.test(fieldKey))
    return "section-services";
  return null;
}

function sectionForSectionId(sectionId: string): string | null {
  if (SECTION_IDS.has(sectionId)) return sectionId;
  const alias = SECTION_ID_ALIASES[sectionId];
  if (alias) return alias;
  const card = PRICE_CARD_ID.exec(sectionId)?.[1];
  return (card && PRICE_CARD_SECTIONS[card]) || null;
}

export function sectionForTarget(target: {
  sectionId?: string;
  fieldKey?: string;
}): string | null {
  return (
    (target.fieldKey ? sectionForFieldKey(target.fieldKey) : null) ??
    (target.sectionId ? sectionForSectionId(target.sectionId) : null)
  );
}
